import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';

export default function PrivateRoutes() {
    const login = localStorage.getItem("login") === "true";
    return login ? <Outlet /> : <Navigate to="/login" replace />
}
